import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('ep-nav-list-box')
export class EPNavListBox extends LitElement {

  render() {
    return html`
      <div class="box">
        <slot></slot>
      </div>
    `
  }

  static styles = css`
    :host {
      display: block;
    }

    * {
      box-sizing: border-box;
    }

    .box {
      background-color: rgb(255, 255, 255);
      box-shadow: rgba(27, 31, 36, 0.12) 0px 1px 3px, rgba(66, 74, 83, 0.12) 0px 8px 24px;
      border-radius: 12px;
      overflow: hidden;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-nav-list-box': EPNavListBox
  }
}
